import {Injectable} from '@angular/core';
import {ToastrService} from 'ngx-toastr';
import {TranslateService} from "@ngx-translate/core";
import swal, {SweetAlertResult} from "sweetalert2";

@Injectable({
    providedIn: 'root'
})
export class NotificationService {
    private toastrConfig = {
        timeOut: 8000,
        closeButton: true,
        enableHtml: true,
        toastClass: 'alert alert-success alert-with-icon',
        positionClass: 'toast-bottom-right'
    };

    constructor(public toastr: ToastrService,
                private translate: TranslateService) {
    }

    public swalConfirm(title:string, text:string, confirmText:string, cancelText:string):Promise<SweetAlertResult>{
        return swal.fire({
                title: title,
                text: text,
                type: "warning",
                showCancelButton: true,
                confirmButtonText: confirmText,
                cancelButtonText: cancelText,
                confirmButtonClass: "btn btn-success mr-1",
                cancelButtonClass: "btn btn-danger",
                buttonsStyling: false
            })
    }

    showSuccessWithoutTranslation(message: string) {
        this.toastr.success(
            '<span class=" tim-icons icon-bell-55"></span>' + message,
            '',
            this.toastrConfig
        );
    }

    showSuccess(message?: string) {
        if (message == null || message == "") {
            message = "general.success";
        }
        this.showSuccessWithoutTranslation(this.translate.instant(message));
    }

    showError(message, title?) {
        this.toastrConfig.toastClass = 'alert alert-danger alert-with-icon';
        this.toastr.error('<span class=" tim-icons icon-alert-circle-exc"></span>' + this.translate.instant(message),
            this.translate.instant(title ? title : 'general.error'),
            this.toastrConfig
        );
    }

    showWarning(message) {
        this.toastrConfig.toastClass = 'alert alert-warning alert-with-icon';
        this.toastr.warning('<span class=" tim-icons icon-alert-circle-exc"></span>' + this.translate.instant(message),
            this.translate.instant('general.warning'),
            this.toastrConfig
        );
    }

    showErrorWithoutTranslate(message, title?) {
        this.toastrConfig.toastClass = 'alert alert-danger';
        this.toastr.error(message,
            this.translate.instant(title?title:'general.error'),
            this.toastrConfig
        );
    }

    showInfo(message) {
        this.toastrConfig.toastClass = 'alert alert-info alert-with-icon';
        this.toastr.info('<span class=" tim-icons icon-volume-98"></span>' + this.translate.instant(message),
            this.translate.instant('general.info'),
            this.toastrConfig
        );
    }

    showSocketNotification(title, message) {
        this.toastrConfig.toastClass = 'alert alert-info alert-with-icon';
        this.toastr.info('<span class=" tim-icons icon-volume-98"></span>' + message,
            this.translate.instant(title),
            this.toastrConfig
        );
    }

    showRequiredError(messageId) {
        this.showErrorWithoutTranslate(this.translate.instant(messageId) + " " + this.translate.instant('general.required') + "!",
        );
    }

    showErrorRawMessage(title, message) {
        this.toastrConfig.toastClass = 'alert alert-danger alert-with-icon';
        this.toastr.error('<span class=" tim-icons icon-alert-circle-exc"></span>' + message, this.translate.instant(title), this.toastrConfig);
    }

}
